import { useMemo } from "react"

import { useSelector } from "react-redux"

import { useUpdatePreferences } from "../../User/hooks/useUpdatePreferences"
import {
  getPricingPreferencesFeature,
  PRICING_PREFERENCES_VERSION
} from "../redux/pricing.constants"
import { selectPricingFilters, selectPricingVisibleFilters } from "../redux/pricing.slice"

// Called by each tab rather than once by the page: `useUpdatePreferences` throttles per instance,
// so switching the key on a live instance could send one tab's pending filters under another's key.
export const usePricingTabPreferences = (tab) => {
  const filters = useSelector(selectPricingFilters(tab))
  const visibleFilters = useSelector(selectPricingVisibleFilters(tab))

  const data = useMemo(
    () => ({ version: PRICING_PREFERENCES_VERSION, filters, visibleFilters }),
    [filters, visibleFilters]
  )

  useUpdatePreferences(getPricingPreferencesFeature(tab), data)
}
